module.exports = __webpack_public_path__ + "img/wx-ewm.2e4058ad.png";